module.exports = __webpack_public_path__ + "img/xuanzhong@2x.9e6807cd.png";